import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light text-center text-lg-start border-top mt-auto">
      <div className="text-center p-3">
        © {new Date().getFullYear()} Admin Panel. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
